import * as React from "react";
import { connect } from "react-redux";

import { isRequestActive } from "redux-request-loading";
import { Modal, Button } from "semantic-ui-react";

import { ClinicLocationTypeName } from "@teamprevent/common/appointment/models";

import { ApplicationState } from "../../models";
import { createClinic } from "../actions";
import { ClinicCreateModel, ClinicType, ClinicLocationType, ClinicErrors } from "../models";
import { CREATE_CLINIC } from "../actionTypes";
import { PartialCustomerListModel } from "../../../crud/customer";

import { CreateForm } from "./CreateForm";

import { goBack } from "redux-little-router";

interface PropsFromState {
    open: boolean;
    clinicTypes: ClinicType[];
    clinicLocationTypes: ClinicLocationType[];
    customers: PartialCustomerListModel[];
    basePath: string;
    errors: ClinicErrors;
    creatingClinic: boolean;
}

interface PropsFromDispatch {
    close: () => void;
    save: (path: string, clinic: ClinicCreateModel) => Promise<void>;
}

interface StateProps {
    open: boolean;
    clinicTypes: ClinicType[];
    clinicLocationTypes: ClinicLocationType[];
    customers: PartialCustomerListModel[];
    errors: ClinicErrors;
    creatingClinic: boolean;
}

interface DispatchProps {
    close: () => void;
    save: (clinic: ClinicCreateModel) => Promise<void>;
}

type AllProps = StateProps & DispatchProps;

class CreateModalUnconnected extends React.Component<AllProps> {

    private createForm: CreateForm;

    public render() {
        return (
            <Modal size="small" open={this.props.open} closeOnDimmerClick={false}>
                <Modal.Header content="Create Clinic" />
                <Modal.Content>
                    <CreateForm
                        clinicTypes={this.props.clinicTypes}
                        clinicLocationTypes={this.props.clinicLocationTypes}
                        createClinicErrors={this.props.errors}
                        customers={this.props.customers}
                        save={this.props.save}
                        ref={instance => this.createForm = instance}
                    />
                </Modal.Content>
                <Modal.Actions>
                    <Button onClick={this.props.close} content="Cancel" />
                    <Button loading={this.props.creatingClinic} disabled={this.props.creatingClinic} onClick={() => this.createForm.submit()} content="Save" />
                </Modal.Actions>
            </Modal>
        );
    }
}

const mapStateToProps = (state: ApplicationState): PropsFromState => ({
    open: state.router.pathname.endsWith("/create"),
    clinicTypes: state.clinicTypes,
    clinicLocationTypes: state.clinicLocationTypes.filter(l => l.name !== ClinicLocationTypeName.mobile),
    basePath: state.router.pathname.substring(0, state.router.pathname.indexOf("/create")),
    errors: state.clinic.clinicErrors,
    creatingClinic: isRequestActive(state, CREATE_CLINIC),
    customers: state.customers
});

const mapDispatchToProps = (dispatch: any): PropsFromDispatch => ({
    close: () => dispatch(goBack()),
    save: (path, clinic) => dispatch(createClinic(path, clinic))
});

const mergeProps = (propsFromState: PropsFromState, propsFromDispatch: PropsFromDispatch): AllProps => {
    const { basePath, ...stateProps } = propsFromState;
    const { save, ...dispatchProps } = propsFromDispatch;
    const dispatchSave = (clinic: ClinicCreateModel) => save(basePath, clinic);
    return {
        ...stateProps,
        ...dispatchProps,
        save: dispatchSave
    };
};

export const CreateModal = connect(mapStateToProps, mapDispatchToProps, mergeProps)(CreateModalUnconnected);
